export const MONTHS = [
    { month: 'Janvier', number: 0 }, { month: 'Fevrier', number: 1 }, { month: 'Mars', number: 2 },
    { month: 'Avril', number: 3 }, { month: 'Mai', number: 4 }, { month: 'Juin', number: 5 },
    { month: 'Juillet', number: 6 }, { month: 'Aout', number: 7 }, { month: 'Septembre', number: 8 },
    { month: 'Octobre', number: 9 }, { month: 'Novembre', number: 10 }, { month: 'Decembre', number: 11 },
]